// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--2dkcw";
export var subheadline = "styles-module--subheadline--1Atvx";
export var headline = "styles-module--headline--1Lajh";
export var items = "styles-module--items--2cTla";
export var item = "styles-module--item--2O-at";
export var answer = "styles-module--answer--2Rz1t";
export var open = "styles-module--open--1vBjB";
export var trigger = "styles-module--trigger--29mP4";